import Passwordform from "@/components/main/user/passwordmanagement/component.vue";
import BmodalSimple from "@/components/singles/BModalSimple/component.vue";

export default {
  name: "",
  components: { Passwordform, BmodalSimple },
  props: [],
  data() {
    return {
      showModal: false
    };
  },
  beforeDestroy() {},
  computed: {},
  created() {
    this.$helpers.GetAuthInfo();
  },
  mounted() {},
  methods: {}
};
